import { Context, Middleware } from '@nuxt/types'
import { Routes } from '~/constants'

const checkAnketIDMiddleware: Middleware = ({ redirect }: Context): void => {
  if (process.client)
    if (!window.localStorage.getItem('anket_id')) redirect(Routes.INDEX)
}

export default checkAnketIDMiddleware
